module.exports = __webpack_public_path__ + "src/assets/games/42/34.jpg";